import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/utils/shadcn/utils'

const skeletonVariants = cva(
  'animate-pulse rounded-md bg-moment-blue-grey-200 dark:bg-moment-blue-grey-1000',
  {
    variants: {
      variant: {
        default: 'h-4',
        heading: 'h-7',
        subheading: 'h-5',
        avatar: 'rounded-full',
        icon: 'rounded-md',
      },
      size: {
        sm: 'w-16',
        md: 'w-32',
        lg: 'w-48',
        xl: 'w-64',
        '2xl': 'w-80',
        full: 'w-full',
        square: 'aspect-square',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  },
)

interface SkeletonProps extends VariantProps<typeof skeletonVariants> {
  className?: string
  hidden?: boolean
}

/**
 * @deprecated Use `Skeleton` from `@moment/design-system-ui/skeleton` instead.
 */
export function Skeleton({ variant, size, className, hidden }: SkeletonProps) {
  return (
    <div
      className={cn(skeletonVariants({ variant, size }), className)}
      role="status"
      aria-label={hidden ? undefined : 'Loading...'}
      aria-hidden={hidden}
    />
  )
}
